<script>
export default {
  name: "new-bid-input",
  props: {
    inputValue: Number,
    label: String,
    formatAsCurrency: Boolean,
    max: Number,
    currentBid: Number,
  },
  data: function() {
    return {
      data: [],
      error: false,
    };
  },
  methods: {
    updateValue: function(value) {
      var parsed = value ? parseInt(value.replace(/\,/g, "")) : null;
      if (parsed >= this.currentBid) {
        this.error = true;
      } else {
        this.error = false;
      }
      this.$emit("input", parsed);
    },
    addCommas: function(x) {
      if (x === null) {
        return null;
      } else if (isNaN(x)) {
        return 0;
      }
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
  computed: {
    currency: function() {
      return this.$store.state.activeAuction.currency || "£";
    },
  },
};
</script>
<template>
  <div style="margin-bottom:0.5rem;">
    <label v-if="label">{{ label }}</label>
    <input v-if="!formatAsCurrency" type="number" class="form-control" :value="inputValue" v-on:input="updateValue($event.target.value)" />
    <div v-else class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">{{ currency }}</span>
      </div>
      <input type="text" class="form-control" :value="addCommas(inputValue)" v-on:input="updateValue($event.target.value)" /><br />
    </div>
  </div>
</template>
<style scoped>
.input-error {
  color: red;
  width: 100%;
  font-size: 12px;
}
</style>
